import React from "react";
import styles from "./BlogPostPage.module.css";
import Margin from "../Margin";
import blogPosts from "./blogPosts.json";
import LanguageSwitch from "./LanguageSwitch";
import { labels, localizePost } from "./blogLanguage";

const BlogPostPage = ({ slug, language, onLanguageChange }) => {
  const sourcePost = blogPosts.find((item) => item.slug === slug);
  const post = sourcePost && localizePost(sourcePost, language);

  if (!post) {
    return (
      <main className={styles.page} lang={language}>
        <a href="#/blog" className={styles.backButton}>{labels[language].blog}</a>
        <article className={styles.inner}>
          <Margin size={4} />
          <LanguageSwitch language={language} onLanguageChange={onLanguageChange} />
          <h1 className={styles.title}>{labels[language].notFound}</h1>
          <p className={styles.date}>{labels[language].selectPost}</p>
        </article>
      </main>
    );
  }

  return (
    <main className={styles.page} lang={language}>
      <a href="#/blog" className={styles.backButton}>{labels[language].blog}</a>
      <article className={styles.inner}>
        <Margin size={4} />
        <LanguageSwitch language={language} onLanguageChange={onLanguageChange} />
        <h1 className={styles.title}>{post.title}</h1>
        <p className={styles.date}>{post.date}</p>
        {post.content.map((paragraph, index) => (
          <p key={index} className={styles.body}>{paragraph}</p>
        ))}
      </article>
    </main>
  );
};

export default BlogPostPage;
